// state.js

export default {
    brandList: [],
};
